module.exports = __webpack_public_path__ + "static/media/suporte_active.e6129531.svg";